import { FC } from 'react';
import { ClassIcon, DEFAULT_CLASS_ICON, MULTI_CLASS_ICON, SITE_ICON } from './classIcons';

type BadgeVariant = 'class' | 'multi' | 'site' | 'empty';

interface Props {
  variant: BadgeVariant;
  icon?: string | null;
  size?: 'md' | 'sm';
}

const ART_BY_VARIANT: Record<Exclude<BadgeVariant, 'class'>, string> = {
  multi: MULTI_CLASS_ICON,
  site: SITE_ICON,
  empty: DEFAULT_CLASS_ICON,
};

const ClassBadge: FC<Props> = ({ variant, icon = null, size = 'md' }) => {
  // The design-system icons carry their own circle, border and fill.
  const Icon = ClassIcon(variant === 'class' ? icon : ART_BY_VARIANT[variant]);
  const badgeSize = size === 'sm' ? 32 : 40;

  return (
    <Icon
      className="nc_class-badge nc_class-badge--art"
      width={badgeSize}
      height={badgeSize}
      data-testid={`classBadge${variant === 'class' ? '' : variant.charAt(0).toUpperCase() + variant.slice(1)}`}
      aria-hidden="true"
    />
  );
};

export default ClassBadge;
